module.exports = __webpack_public_path__ + "static/media/election-icon.1be45f54.svg";